import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { JustificationOption } from "interfaces/justification";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_JUSTIFICATION_" }
);

export interface ListJustificationsState extends IState {
  data: JustificationOption[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: JustificationOption[];
}

const INITIAL_STATE: ListJustificationsState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListJustificationsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ListJustificationsState,
  action: ISuccessListUnitsAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListJustificationsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listJustifications = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListJustificationsTypes = Types;
export const ListJustificationsActions = Creators;
